'use client';

import { useEffect, useState } from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { useLanguage } from '@/lib/LanguageContext';

export function ServiceHealthCheck() {
    const { t } = useLanguage();
    const [isError, setIsError] = useState(false);
    const [checking, setChecking] = useState(true);

    const checkHealth = async () => {
        try {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 5000); // 5s timeout

            const res = await fetch('/api/health', {
                signal: controller.signal,
                cache: 'no-store'
            });

            clearTimeout(timeoutId);

            if (!res.ok) {
                throw new Error('Health check failed');
            }
            setIsError(false);
        } catch (err) {
            console.error('Service health check failed:', err);
            setIsError(true);
        } finally {
            setChecking(false);
        }
    };

    useEffect(() => {
        checkHealth();

        // Optional: Periodically check? Or just once on load.
        // Let's stick to once on load as per requirements "when user opens page".
    }, []);

    if (!isError) return null;

    return (
        <div className="fixed top-0 left-0 right-0 z-[100] bg-destructive text-destructive-foreground px-4 py-2 flex items-center justify-center gap-2 text-sm shadow-md animate-in slide-in-from-top">
            <AlertTriangle className="h-4 w-4" />
            <span>
                {t('serviceHealth.maintenance')}
            </span>
            <button
                onClick={() => {
                    setChecking(true);
                    checkHealth();
                }}
                disabled={checking}
                className="ml-2 p-1 hover:bg-black/10 rounded-full transition-colors"
                title="Retry connection"
            >
                <RefreshCw className={`h-4 w-4 ${checking ? 'animate-spin' : ''}`} />
            </button>
        </div>
    );
}
